import { useMemo } from 'react';
import { useAccount } from '../../contexts/account/AccountContexts';
import { Addons } from '../../types/account/Addons';

const useAddon = (addon: Addons): boolean => {
  const { accountResponse } = useAccount();

  return useMemo(() => {
    return Boolean(accountResponse?.addons?.includes(addon));
  }, [accountResponse, addon]);
};

export default useAddon;
